import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

export const Container = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  width: 100%;
`;

export const ImageContainer = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  height: 2rem;
  width: 2rem;
  margin: ${({ theme }) =>
    `${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} 0`};

  pointer-events: none;
`;

export const BlurImageContainer = styled.div`
  width: 100%;
  height: 100%;

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  overflow: hidden;
`;

export const ImageIconContainer = styled.span`
  display: block;
  padding: ${({ theme }) => theme.spacing(0.75)};

  background: ${({ theme }) => theme.palette.grey[100]};
  border-radius: ${({ theme }) => theme.spacing(1.5)};

  font-size: 1.4rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[700]};
`;

export const ColorDot = styled.span<{ $color: string }>`
  position: absolute;
  bottom: ${({ theme }) => `-${theme.spacing(0.75)}`};
  right: ${({ theme }) => `-${theme.spacing(0.75)}`};

  display: block;
  height: 1rem;
  width: 1rem;

  border: ${({ theme }) =>
    `${theme.spacing(0.5)} solid ${theme.palette.background.default};`};
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;

export const CompletedContainer = styled.span`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 1.2rem;
  height: 1.2rem;

  transform: translate(33%, -33%);
  background: ${({ theme }) => theme.palette.success.main};
  border-radius: 50%;

  font-size: 0.8rem;
  color: ${({ theme }) => theme.palette.success.contrastText};
`;

export const HeaderBody = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};

  min-width: 0;
`;

export const LinkIconContainer = styled.span<{ $isFaded: boolean }>`
  display: block;

  transform: rotate(180deg);
  transition: opacity 200ms;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};

  ${({ $isFaded, theme }) =>
    $isFaded &&
    css`
      margin-left: ${theme.spacing(2)};
      transform: rotate(0deg);
    `};
`;

export const TitleContainer = styled(QueryNavLink)`
  display: flex;
  align-items: center;
  min-width: 0;

  text-decoration: none;
  color: inherit;
`;

export const Title = styled.span<{
  $isFrozen: boolean;
  $isSmall: boolean;
  $isCompleted: boolean;
}>`
  ${({ $isSmall, theme }) =>
    typographyToCss(
      $isSmall ? theme.typography.subtitle2 : theme.typography.h6,
    )};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $isCompleted }) =>
    $isCompleted &&
    css`
      text-decoration: line-through;
    `};

  ${({ $isFrozen, theme }) =>
    $isFrozen &&
    css`
      color: ${theme.palette.text.secondary};
    `};
`;

export const DeadlineContainer = styled.span`
  display: inline-flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;

  font-size: 1.2rem;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Date = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  white-space: nowrap;
`;

export const Dot = styled.span`
  display: inline-block;

  width: ${({ theme }) => theme.spacing(1)};
  height: ${({ theme }) => theme.spacing(1)};

  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.grey['300']};
`;
